'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { ArrowRight } from 'lucide-react';
interface AudienceGroup {
  audience: string;
  title: string;
  description: string;
  cta: {
    label: string;
    href: string;
  };
  accent: {
    /** Card ring/border + hover treatment. */
    card: string;
    /** Audience eyebrow line color. */
    audience: string;
    /** CTA link color. */
    link: string;
    /** Top accent bar gradient. */
    bar: string;
  };
}
const GROUPS: AudienceGroup[] = [{
  audience: 'For Founders, Brands & Retailers',
  title: 'Get Inspired.  Discover & Connect with the Right Help.  Make your Next Moves',
  description: 'Sizzle helps you better understand how consumer demand and the consumer journey works, get inspired on action to drive that demand for your products/brand,  discover and connect with the right help to execute, and connect with opportunities.',
  cta: {
    label: 'Explore Sizzle for Brands & Retailers',
    href: '/demand'
  },
  accent: {
    card: 'ring-primary-200 hover:ring-primary-300 hover:shadow-primary-500/20',
    audience: 'text-primary-600',
    link: 'text-primary-600 hover:text-primary-700',
    bar: 'from-primary-500 to-orange-400'
  }
}, {
  audience: 'You work with Brands & Retailers',
  title: 'Be Discovered More. Get More Enquiries. Connect with more Opportunities',
  description: 'Buyers, distributors, importers, brokers, consultants, agencies, and suppliers — Sizzle gives brands and retailers another channel to discover you and connect to utilise your product and service offerings.',
  cta: {
    label: 'Explore Sizzle for the Trade',
    href: '/directory'
  },
  accent: {
    card: 'ring-gray-300 hover:ring-gray-400 hover:shadow-gray-500/20',
    audience: 'text-gray-500',
    link: 'text-gray-900 hover:text-gray-700',
    bar: 'from-gray-800 to-gray-600'
  }
}];
export function AudienceSplitSection() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <section className="border-y border-orange-100 bg-gradient-to-b from-orange-50 via-white to-white"><div className="mx-auto max-w-[1200px] px-5 pb-9 pt-16 sm:px-8 sm:pb-12 sm:pt-20 lg:px-12"><div className="mt-7 grid gap-8 sm:mt-8 lg:grid-cols-2 lg:gap-12">{GROUPS.map(_temp)}</div></div></section>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(group) {
  return <article key={group.title} className={`relative flex flex-col overflow-hidden rounded-2xl bg-white p-5 shadow-lg ring-1 transition-all hover:-translate-y-1 hover:shadow-2xl sm:p-6 ${group.accent.card}`}><div className={`absolute inset-x-0 top-0 h-1 bg-gradient-to-r ${group.accent.bar}`} aria-hidden="true" /><p className={`text-lg font-bold uppercase tracking-wider  ${group.accent.audience}`}>{group.audience}</p><h3 className="mt-1.5 text-xl font-black leading-tight text-gray-950 sm:text-2xl">{group.title}</h3><p className="mt-2 text-base leading-7 text-gray-600">{group.description}</p></article>;
}